import React from "react";
import PaymentGatewayTesterMessage from "./PaymentGatewayTesterMessage";
import PaymentGatewayTesterSteps from "./PaymentGatewayTesterSteps";
import PaymentGatewayTesterForm from "./PaymentGatewayTesterForm";
import PaymentGatewayTesterActions from "./actions/PaymentGatewayTesterActions";
import PaymentGatewayTesterHeader from "./PaymentGatewayTesterHeader";
import PaymentGatewayTesterCreditCard from "./PaymentGatewayTesterCreditCard";
import ReactPortalsRoot from "../ReactPortalsRoot/ReactPortalsRoot";
import ModalWarning from "../ModalWarning/ModalWarning";
import DateHelper from "../DateHelper/DateHelper";
import { loadStripe } from '@stripe/stripe-js';
import { Elements, ElementsConsumer, CardElement, PaymentElement } from '@stripe/react-stripe-js';

var objectAssign = require('object-assign');

class PaymentGatewayTesterGateway extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      currentStep: '',
      currentGatewayOptions: this.getGatewayOptions(this.props.gateway ? this.props.gateway.name : ''),
      gateway: this.props.gateway,
      gatewayOptions: this.props.gatewayOptions,
      mode: this.props.gateway && this.props.gateway.credentials ? 'test' : 'edit',
      stripe: null,
      displayCardElement: false,
      nameOnCard: null, 
    }
    this.onDelete = this.onDelete.bind(this);
    this.onEdit = this.onEdit.bind(this);
    this.onGatewayChange = this.onGatewayChange.bind(this);
    this.onSaveGatewayCredentials = this.onSaveGatewayCredentials.bind(this);
    this.onTest = this.onTest.bind(this);
    // this.onUpdateCreditCard = this.onUpdateCreditCard.bind(this);
  }
  async componentDidMount(){

    if (this.state.gateway.public_test_key){
      const stripe = await loadStripe(this.state.gateway.public_test_key, {
        locale: navigator.languages && navigator.languages.length
          ? navigator.languages[0]
          : navigator.language
      });

      this.setState({ stripe: stripe});
    };
    
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({gateway: nextProps.gateway});
  }

  getGatewayOptions(name) {
    if (this.props.gatewayOptions && this.props.gatewayOptions.length) {
      for (var i = 0, ilen = this.props.gatewayOptions.length; i < ilen; i++) {
        if (this.props.gatewayOptions[i][1] == name) {
          return this.props.gatewayOptions[i];
        }
      }
    }
    return [];
  }

  render() {
    if (this.state.mode == 'test') {
      // test
      return (
        <div className="paymentGatewayTesterGateway">
          {this.props.readOnly ? null : <PaymentGatewayTesterHeader {...this.state} onTest={() => this.setState({displayCardElement: true})} onEdit={this.onEdit} onDelete={this.onDelete} />}
          <PaymentGatewayTesterMessage {...this.state} date_format={this.props.date_format} time_format={this.props.time_format} />
          {/* {this.props.readOnly ? null : <PaymentGatewayTesterCreditCard {...this.state} onUpdateCreditCard={this.onUpdateCreditCard} stripe={this.state.stripe} testGateway={this.onTest}/>} */}
          <PaymentGatewayTesterSteps {...this.state} />
          {
            this.state.displayCardElement
            ?
              <Elements 
                stripe={this.state.stripe} 
              >
                <ElementsConsumer>
                  {({ stripe, elements }) => (
                    this.renderCardElementPopover(stripe, elements)
                  )}
                </ElementsConsumer>
              </Elements>
            : 
              null
          }
        </div>
      );
    } else {
      // edit
      return (
        <div className="paymentGatewayTesterGateway">
          <PaymentGatewayTesterForm {...this.state} onSaveGatewayCredentials={this.onSaveGatewayCredentials} onGatewayChange={this.onGatewayChange} />
        </div>
      );
    }
  }

  renderCardElementPopover = (stripe, elements) => {
    return(
      <ReactPortalsRoot
        children={[
          <ModalWarning
            key="body"
            title={I18n.t("session_timeout_warning")}
            body={this.renderCardElement()}
            modalFooter={this.renderTestCancelButtons(stripe, elements)}
            onCancel={() => this.setState({displayCardElement: false})}
          />,
        ]}
        wrapperClassNames="ModalWarningWrapper"
      />
    );
  };

  renderCardElement = () => {
    return <PaymentGatewayTesterCreditCard {...this.state} onChangeNameOnCard={this.onChangeNameOnCard} />
  };

  renderTestCancelButtons = (stripe, elements) => {
    return(
      <div className="modal-footer">
        <span className="warning-modal-footer">
          <button className="btn btn-secondary" onClick={() => this.setState({displayCardElement: false})}>{I18n.t('cancel')}</button>
          <button className="btn btn-primary" onClick={(e) => this.onTest(e, elements)}>{I18n.t('test')}</button>
        </span>
      </div>
    );
  };

  onChangeNameOnCard = (e) => {
    this.setState({nameOnCard: e.target.value})
  };

  onTest = async (event, elements) => {
    event.preventDefault();

    var stripe = this.state.stripe
    var cardElement = elements.getElement(CardElement)

    if (!stripe || !elements) {
      return;
    }
    const result = await stripe.createPaymentMethod({
      type: 'card',
      card: cardElement,
      billing_details: {
        name: this.state.nameOnCard,
      },
    });
    
    
    
    
    
    // .createSource(
    //   cardElement,
    //   {
    //     type: 'card',
    //     owner: {
    //       name: 'Jimmy Taps',
    //       email: 'benporter@maxreservations.com'
    //     },
    //     usage: 'reusable',
    //   }
      
      // );
      this.setState({ mode: 'test' });

    if (result.error) {
      console.log(result.error.message);
    } else {
      this.setState({ mode: 'test', displayCardElement: false });

      this.test( result.paymentMethod )
    };
  };

  onEdit() {
    this.setState({mode: 'edit'});
  };

  onDelete() {
    BootstrapDialog.show({
      title: I18n.t('confirm_delete_payment_gateway'),
      message: I18n.t('are_you_sure_you_want_to_delete_this_payment_gateway'),
      buttons: [{
        label: I18n.t('cancel'),
        action: (dialog) => {
          dialog.close();
        }
      }, {
        cssClass: 'btn-primary',
        label: I18n.t('yes_im_sure_delete_it'),
        action: (dialog) => {
          dialog.close();
          PaymentGatewayTesterActions.deleteGateway(this.props.gateway.id);
        }
      }]
    });
  }

  onGatewayChange(name) {
    this.props.gateway.name = name;
    this.setState({currentGatewayOptions: this.getGatewayOptions(name)});

    this.forceUpdate();
  }

  onSaveGatewayCredentials(name, credentials) {
    
    var params = {
      id: this.state.gateway.id,
      name: name,
      credentials: credentials,
      property_id: this.props.property_id,
    };

    $('.paymentGatewayTester .loadingOverlay').fadeIn('fast');

     $.ajax({
        type: 'POST',
        url: '/superadmin/payment-gateways/save',
        data: params,
    }).done( async (data) => {
      $('.paymentGatewayTester .loadingOverlay').fadeOut('fast');
      if (data.success) {
        const stripe =  await loadStripe(data.success.public_test_key, {
          locale: navigator.languages && navigator.languages.length
            ? navigator.languages[0]
            : navigator.language
        });

        this.setState({ stripe: stripe });


        this.state.mode = 'test';
        this.state.gateway = data.success;
        PaymentGatewayTesterActions.setGateway(data.success)
      }


      // window.parent.$(window.parent).trigger('paymentGatewayChange');
      // this.forceUpdate();
    });
  }

  // onUpdateCreditCard(card) {
  //   objectAssign(this.state.gateway, card);
  // }

  clearTestStatus() {
    if (this.state.gateway) {
      this.state.gateway.credentials_step = null;
      this.state.gateway.store_card_step = null;
      this.state.gateway.authorize_step = null;
      this.state.gateway.capture_step = null;
      this.state.gateway.void_step = null;
      this.state.gateway.unstore_card_step = null;

      this.state.gateway.credentials_text = null;
      this.state.gateway.store_card_text = null;
      this.state.gateway.authorize_text = null;
      this.state.gateway.capture_text = null;
      this.state.gateway.void_text = null;
      this.state.gateway.unstore_card_text = null;
    }
  }

  test(tokenOBJ) {
    // clear out current test status
    this.clearTestStatus();
    this.forceUpdate();

      this.testCredentials(tokenOBJ).then( () => this.testStoreCard(tokenOBJ) ).then( () => this.testAuthorize() ).then( () => this.testCapture() ).then( () => this.testVoid() ).then( () => this.testUnstoreCard() ).then(() => {
      var { gateway } = this.state
      gateway.tested_at = DateHelper.server();
      gateway.tested_successfully_at = DateHelper.server();
      this.setState({currentStep: '', gateway: gateway});
      PaymentGatewayTesterActions.setGateway(gateway);
    }).catch(() => {
      var { gateway } = this.state
      gateway.tested_at = DateHelper.server();
      gateway.tested_successfully_at = null;
      this.setState({currentStep: '', gateway: gateway});
      PaymentGatewayTesterActions.setGateway(gateway);
    });
  }

  testCredentials(tokenOBJ) {
    return new Promise((resolve, reject) => {

      this.state.currentStep = 'credentials';
      this.forceUpdate();

      var params = Object.assign({}, this.state.gateway)
      params.token = tokenOBJ

      $.ajax({
          type: 'POST',
          url: '/superadmin/payment-gateways/test-credentials',
          data: params,
      }).done((data) => {
        this.setState({gateway: data.success ? data.success : data.error});
        data.success ? resolve() : reject();
      });
    });
  }

  testStoreCard(tokenOBJ) {
    return new Promise((resolve, reject) => {

      this.state.currentStep = 'store_card';
      this.forceUpdate();

      var params = Object.assign({}, this.state.gateway)
      params.token = tokenOBJ

      $.ajax({
          type: 'POST',
          url: '/superadmin/payment-gateways/test-store-card',
          data: params,
      }).done((data) => {
        setTimeout(() => {
          this.setState({gateway: data.success ? data.success : data.error});
          data.success ? resolve() : reject();
        }, 1000);
      });
    });
  }

  testAuthorize() {
    return new Promise((resolve, reject) => {

      this.state.currentStep = 'authorize';
      this.forceUpdate();

      $.ajax({
          type: 'POST',
          url: '/superadmin/payment-gateways/test-authorize',
          data: this.state.gateway,
      }).done((data) => {
        setTimeout(() => {
          this.setState({gateway: data.success ? data.success : data.error});
          data.success ? resolve() : reject();
        }, 1000);
      });
    });
  }

  testCapture() {
    return new Promise((resolve, reject) => {

      this.state.currentStep = 'capture';
      this.forceUpdate();

      $.ajax({
          type: 'POST',
          url: '/superadmin/payment-gateways/test-capture',
          data: this.state.gateway,
      }).done((data) => {
        setTimeout(() => {
          this.setState({gateway: data.success ? data.success : data.error});
          data.success ? resolve() : reject();
        }, 1000);
      });
    });
  }

  testVoid() {
    return new Promise((resolve, reject) => {

      this.state.currentStep = 'void';
      this.forceUpdate();

      $.ajax({
          type: 'POST',
          url: '/superadmin/payment-gateways/test-void',
          data: this.state.gateway,
      }).done((data) => {
        setTimeout(() => {
          this.setState({gateway: data.success ? data.success : data.error})
          data.success ? resolve() : reject();
        }, 1000);
      });
    });
  }

  testUnstoreCard() {
    return new Promise((resolve, reject) => {

      this.state.currentStep = 'unstore_card';
      this.forceUpdate();

      $.ajax({
          type: 'POST',
          url: '/superadmin/payment-gateways/test-unstore-card',
          data: this.state.gateway,
      }).done((data) => {
        setTimeout(() => {
          this.setState({gateway: data.success ? data.success : data.error})
          data.success ? resolve() : reject();
        }, 1000);
      });
    });
  }

  updateCreditCard(card) {
    if (this.state.gateway) {
      objectAssign(this.state.gateway, card);
    }
  }

  updateGatewayName(name) {
    if (this.state.gateway) {
      this.state.gateway.name = name;
    }
  }
};

export default PaymentGatewayTesterGateway
